/**
 * Partner Feature 정의 — fez-front-taap `src/apis/types/partnerType.ts` 의 `ContractPartner` 네임스페이스에서
 * 전체 스펙(주석 포함)을 그대로 옮겨 평탄화. court는 namespace 패턴을 사용하지 않으므로 export 평탄화만 수행.
 *
 * LINK - https://pnpt.atlassian.net/wiki/spaces/dsplan/pages/411664436/Central+feature
 */
export enum PartnerFeature {
  /** Ctrl.room 관리비 메뉴 */
  CTRLROOM_NAVIGATION_MAINTENANCE_FEE = "CTRLROOM_NAVIGATION_MAINTENANCE_FEE",
  /** Ctrl.room 공용공간 예약 메뉴 */
  CTRLROOM_NAVIGATION_RESERVATION = "CTRLROOM_NAVIGATION_RESERVATION",
  /** Ctrl.room CS 메뉴 */
  CTRLROOM_NAVIGATION_CS = "CTRLROOM_NAVIGATION_CS",
  /** Ctrl.room 워크오더 메뉴 */
  CTRLROOM_NAVIGATION_WORKORDER = "CTRLROOM_NAVIGATION_WORKORDER",
  /** Taap 도와주세요(불편접수) 버튼 표시 */
  FEATURE_TAAP_VOC_BUTTON = "FEATURE_TAAP_VOC_BUTTON",
  /** Taap 도와주세요(불편접수) 기능 사용 */
  FEATURE_TAAP_VOC = "FEATURE_TAAP_VOC",
  /** Taap 공용공간 예약시 후불정산 기능 */
  FEATURE_RESERVATION_POST_PAYMENT = "FEATURE_RESERVATION_POST_PAYMENT",
  /** Taap 로봇 주문 기능 */
  FEATURE_TAAP_ORDER_ROBOT = "FEATURE_TAAP_ORDER_ROBOT",
  /** Taap 주차 연동 - KPS */
  FEATURE_PARKING_KPS = "FEATURE_PARKING_KPS",
  /** Taap 주차 연동 - 아마노 */
  FEATURE_PARKING_AMANO = "FEATURE_PARKING_AMANO",
  /** Taap 주차 연동 - iParking */
  FEATURE_PARKING_IPARKING = "FEATURE_PARKING_IPARKING",

  /**
   * Taap 노출 출입 QR 타입(AC1 - 숫자 16자리 제공)\
   * 기본값은 AC2 사용
   * @default: off */
  FEATURE_AC1_QR = "FEATURE_AC1_QR",
  /** Taap 차량대여 @default: off */
  FEATURE_TAAP_CAR_RENTAL_TURU = "FEATURE_TAAP_CAR_RENTAL_TURU",
  /** Taap에서 earln을 통한 퀵/택배 서비스를 제공합니다. @default: off */
  FEATURE_TAAP_QUICK_DELIVERY_EARLN = "FEATURE_TAAP_QUICK_DELIVERY_EARLN",
  /** Taap에 PEM 기능을 제공 @default: off */
  FEATURE_TAAP_PEM = "FEATURE_TAAP_PEM",
  /** 해리티지 아이티 CCTV 연동 @default: off */
  FEATURE_CCTV = "FEATURE_CCTV",
  /** Taap에서 QR 스캔 출입 기능을 제공합니다. @default: off */
  TAAP_DOOR_OPEN_QR = "TAAP_DOOR_OPEN_QR",
  /** Taap 예약현황의 방문자초대에 승인상태를 표시 @default: off */
  FEATURE_ACCESS_GROUP_VISITOR_APPROVAL = "FEATURE_ACCESS_GROUP_VISITOR_APPROVAL",
  /** Taap의 방문자 초대 화면에서 출입 그룹 영역의 표시 여부 @default: off */
  TAAP_VISITOR_ACCESS_GROUP = "TAAP_VISITOR_ACCESS_GROUP",
  /** 방문자 셀프 등록웹을 제공합니다. @default: off */
  FEATURE_VISITOR_SELF_REGIST = "FEATURE_VISITOR_SELF_REGIST",
  /** IoT 고도화 @default: off */
  FEATURE_IOT_CONTROL = "FEATURE_IOT_CONTROL",
  /** Taap에서 마로솔의 로봇 서비스를 제공합니다. @default: off */
  TAAP_ROBOT_SOLLINK = "TAAP_ROBOT_SOLLINK",
  /** Taap 에서 커뮤니티 기능을 제공합니다. @default: off */
  FEATURE_COMMUNITY = "FEATURE_COMMUNITY",
  /** Taap에서 환경 정보 버튼을 노출합니다. @default: off */
  TAAP_ENVIRONMENT_STATUS = "TAAP_ENVIRONMENT_STATUS",
  /** Taap TaapSpace @default: off */
  TAAP_TAAPSPACE = "TAAP_TAAPSPACE",
  /** Taap/Ctrl.Room에서 외부 링크 설정 및 연결 기능을 제공합니다. @default: off */
  FEATURE_CUSTOM_LINK = "FEATURE_CUSTOM_LINK",
  /** S1 플랫폼 등록 기능 활성화 @default: off */
  TAAP_ACCESS_S1 = "TAAP_ACCESS_S1",
  /** Suprema 플랫폼 등록 기능 활성화 @default: off */
  TAAP_ACCESS_SUPREMA = "TAAP_ACCESS_SUPREMA",
  /** 홈 QR 코드 노출 활성화 @default: on */
  TAAP_HOME_QR = "TAAP_HOME_QR",
  /** 방문자 초대에 대한 이용자 마스터(입주사 관리자) 승인 @default: off */
  FEATURE_VISITOR_TENANT_MANAGER_APPROVAL = "FEATURE_VISITOR_TENANT_MANAGER_APPROVAL",
}

/**
 * 계약 이용자 파트너 정보 DTO (TPA01)
 */
export interface PartnerDto {
  /** 파트너 아이디 */
  id: string | number;
  /** 계약 관리 아이디 */
  contractManageId: string | number;
  /** 계약 아이디 */
  contractId: string | number;
  /** 허용 기능 목록 */
  features: Array<PartnerFeature>;
}

/**
 * TPA01. 계약 이용자 파트너 정보 조회 응답
 */
export interface PartnerInformationResponse {
  partner: PartnerDto;
}
